<div class="table-view flex flex-col">
    <div class="title flex flex-row hide">
        <strong>Configuration</strong>
        <!--QNR:-->
        <!-- <div class="name" matTooltip="{{excelTableInput.questionnaireName}}">{{excelTableInput.questionnaireName}}</div>

         <button (click)="setData('Questionnaire Name','questionnaireName','qnrTitle')"
                 matTooltip="Rename"
                 mat-icon-button class="icon-dropdown-button">
             <mat-icon>create</mat-icon>
         </button>-->
        <button *ngIf="isAutoDetectVisible" mat-button class="action-button h-n-35 m-t-10" (click)="autoDetect()">
            Auto Detect
        </button>

    </div>

    <div class="table-header">

        <div class="left-side">
            <div class="qnr-name-container">
                <strong>Configuration</strong>
                @if(tableConfigJson[tableType]?.Standard && tableConfigJson[tableType]?.Transposed) {
                
                    <strong style="font-size: 8px;
                    line-height: normal;
                    position: relative;
                    top: -2px;
                    background: #FDAC34;
                    border-radius: 3px;
                    padding-inline: 3px;
                    padding-block: 2px;
                    left: 3px;">{{ transposeTableType === 'Transposed' ? 'Transposed' : 'Standard' }}</strong>
                }
            </div>
            @if(tableConfigJson[tableType]?.Standard && tableConfigJson[tableType]?.Transposed) {
                <div class="toggle-container">
                    <strong style="font-size: 12px;">Transpose</strong>&nbsp;
                    <label class="switch" matTooltip="Toggle between Standard and Transposed view" >
                        <mat-slide-toggle style="transform: scale(.8);" [checked]="transposeTableType === 'Transposed'" (change)="toggleTable()" data-cy="excel-table-input-card_transpose-toggle"></mat-slide-toggle>
                    </label>
                </div>
            }
        </div>

        <ul class="buttons">
            <li *ngIf="isAutoDetectVisible">
                <a data-cy="auto-detect" (click)="autoDetect()">Auto Detect</a>
            </li>

            <li>
              <a data-cy="fetch-fields" [class.disabled]="invalid" (click)="!invalid && apply()">Fetch Fields</a>
            </li>

            <li *ngIf="isTrialBalance === false">
                <a data-cy="assign-data-type" [disabled]="isFetched === false" (click)="assignDataType()">Assign
                    Data Type</a>
            </li>
        </ul>
    </div>


    <dl class="flex flex-row">


    </dl>
    <div class="standardTable" *ngIf="excelTableInput.tableType === 'StandardTable'">

        <table>
            <tbody>
                <tr>
                    <td>Field Header Row</td>
                    <td>
                        <div class="flex items-center">
                            <span>{{excelTableInput.headerRow}}</span>
                            <button data-cy="edit-header-row" (click)="setData('Header Row','headerRow','Row')" matTooltip="Edit" mat-icon-button
                                class="icon-dropdown-button">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>
                    </td>


                </tr>
                <tr>
                    <td>Field Start Column:</td>
                    <td>
                        <div class="flex items-center">
                            <span>{{excelTableInput.startColumn}}</span>
                            <button data-cy="edit-start-column" (click)="setData('Start Column','startColumn','Col')" matTooltip="Edit"
                                mat-icon-button class="icon-dropdown-button">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Field End Column</td>
                    <td>
                        <div class="flex items-center">
                            <span>{{excelTableInput.endColumn}}</span>
                            <button data-cy="edit-end-column" (click)="setData('End Column','endColumn','Col')" matTooltip="Edit" mat-icon-button
                                class="icon-dropdown-button">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>
                    </td>

                </tr>
                <tr>
                    <td>Data Start Row</td>
                    <td>

                        <div class="flex items-center">
                            <span>{{excelTableInput.startDataRow}}</span>
                            <button data-cy="edit-start-data-row" (click)="setData('Start Data Row','startDataRow','Row')" matTooltip="Edit"
                                mat-icon-button class="icon-dropdown-button">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>
                    </td>

                </tr>
                <tr>
                    <td>Data Model Row</td>
                    <td>
                        <div class="flex items-center">
                            <span>{{excelTableInput.modelRow}}</span>
                            <button data-cy="edit-model-row" *ngIf="excelTableInput.isDefaultModelRowLocked == false"
                                (click)="setData('Model Row','modelRow','Row')" matTooltip="Edit" mat-icon-button
                                class="icon-dropdown-button">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>

                    </td>
                </tr>
            </tbody>
        </table>

        <!--<dl class="flex flex-row">
            <dt>Field Header Row:</dt>
            <dd>{{excelTableInput.headerRow}}</dd>
            <button (click)="setData('Header Row','headerRow','Row')"
                    matTooltip="Edit"
                    mat-icon-button class="icon-dropdown-button">
                <mat-icon>create</mat-icon>
            </button>

        </dl>
        <dl class="flex flex-row">
            <dt>Field Start Column:</dt>
            <dd>{{excelTableInput.startColumn}}</dd>
            <button (click)="setData('Start Column','startColumn','Col')"
                    matTooltip="Edit"
                    mat-icon-button class="icon-dropdown-button">
                <mat-icon>create</mat-icon>
            </button>
        </dl>
        <dl class="flex flex-row">
            <dt>Field End Column:</dt>
            <dd>{{excelTableInput.endColumn}}</dd>
            <button (click)="setData('End Column','endColumn','Col')"
                    matTooltip="Edit"
                    mat-icon-button class="icon-dropdown-button">
                <mat-icon>create</mat-icon>
            </button>
        </dl>
        <dl class="flex flex-row">
            <dt>Data Start Row:</dt>
            <dd>{{excelTableInput.startDataRow}}</dd>
            <button (click)="setData('Start Data Row','startDataRow','Row')"
                    matTooltip="Edit"
                    mat-icon-button class="icon-dropdown-button">
                <mat-icon>create</mat-icon>
            </button>
        </dl>
        <dl class="flex flex-row">
            <dt>Data Model Row:</dt>
            <dd>{{excelTableInput.modelRow}}</dd>
            <button *ngIf="excelTableInput.isDefaultModelRowLocked == false"
                    (click)="setData('Model Row','modelRow','Row')"
                    matTooltip="Edit"
                    mat-icon-button class="icon-dropdown-button">
                <mat-icon>create</mat-icon>
            </button>
        </dl>-->

    </div>

    <div class="transposedTable" *ngIf="excelTableInput.tableType === 'TransposedTable'">

        <table>
            <tbody>
                 <tr>
                    <td>Field Header Column</td>
                    <td>
                        <div class="flex items-center">
                            <span>{{excelTableInput.headerColumn}}</span>
                            <button data-cy="edit-header-column" (click)="setData('Header Column','headerColumn','Col')" matTooltip="Edit"
                                mat-icon-button class="icon-dropdown-button">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Field Start Row</td>
                    <td>
                        <div class="flex items-center">
                            <span>{{excelTableInput.startRow}}</span>
                            <button data-cy="edit-start-row" (click)="setData('Start Row','startRow','Row')" matTooltip="Edit" mat-icon-button
                                class="icon-dropdown-button">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>
                    </td>

                </tr>
                <tr>
                    <td>Field End Row</td>
                    <td>
                        <div class="flex items-center">
                            <span>{{excelTableInput.endRow}}</span>
                            <button data-cy="edit-end-row" (click)="setData('End Row','endRow','Row')" matTooltip="Edit" mat-icon-button
                                class="icon-dropdown-button">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>
                    </td>

                </tr>
                <tr>
                    <td>Data Start Column</td>
                    <td>
                        <div class="flex items-center">
                            <span>{{excelTableInput.dataStartColumn}}</span>
                            <button data-cy="edit-data-start-column" (click)="setData('Start Data Column','dataStartColumn','Col')" matTooltip="Edit"
                                mat-icon-button class="icon-dropdown-button">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>
                    </td>

                </tr>
                <tr>
                    <td>Data Model Column</td>
                    <td>
                        <div class="flex">
                            <span>{{excelTableInput.dataModelColumn}}</span>
                            <button data-cy="edit-model-column" *ngIf="excelTableInput.isDefaultModelRowLocked == false"
                                (click)="setData('Model Column','dataModelColumn','Col')" matTooltip="Edit"
                                mat-icon-button class="icon-dropdown-button">
                                <i class="fa-solid fa-pen"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="trialBalance" *ngIf="isTrialBalance">
        <table>
          <tbody>
          @if(tableConfigInfo) {
            @for(tableRowItem of tableConfigInfo.FieldItems; track $index) {
            <tr>
              <td>{{tableRowItem.Title}}</td>
              <td>
                <div class="flex items-center">
                    
                    <span>
                        {{
                          excelTableInput.trialBalanceInputs[tableRowItem.CamelCaseKey]
                            ? excelTableInput.trialBalanceInputs[tableRowItem.CamelCaseKey]
                            : excelTableInput[tableRowItem.CamelCaseKey]
                        }}
                    </span>
                  
                  <button [attr.data-cy]="'edit-' + tableRowItem.CamelCaseKey" (click)="setData(tableRowItem.Title,tableRowItem.CamelCaseKey,tableRowItem.Type,tableConfigJson[tableType].Source,tableRowItem.IsOptional)" matTooltip="Edit"
                          mat-icon-button class="icon-dropdown-button">
                    <i class="fa-solid fa-pen"></i>
                  </button>
                </div>
              </td>
            </tr>
            }
          }
          </tbody>
        </table>
    </div>
  <div class="trialBalance" *ngIf="excelTableInput.tableType === 'Transaction'">
    <table>
      <tbody>
      @if(tableConfigInfo) {
      @for(tableRowItem of tableConfigInfo.FieldItems; track $index) {
      <tr>
        <td>{{tableRowItem.Title}}</td>
        <td>
          <div class="flex items-center">

                    <span>
                        {{
                      excelTableInput.transactionInputs[tableRowItem.CamelCaseKey]
                        ? excelTableInput.transactionInputs[tableRowItem.CamelCaseKey]
                        : ''
                      }}
                    </span>

            <button [attr.data-cy]="'edit-' + tableRowItem.CamelCaseKey" (click)="setData(tableRowItem.Title,tableRowItem.CamelCaseKey,tableRowItem.Type,tableConfigJson[tableType].Source,tableRowItem.IsOptional)" matTooltip="Edit"
                    mat-icon-button class="icon-dropdown-button">
              <i class="fa-solid fa-pen"></i>
            </button>
          </div>
        </td>
      </tr>
      }
      }
      </tbody>
    </table>
  </div>
  <div class="trialBalance" *ngIf="excelTableInput.tableType === 'Matrix'">
    <table>
      <tbody>
      @if(tableConfigInfo) {
      @for(tableRowItem of tableConfigInfo.FieldItems; track $index) {
      <tr>
        <td>{{tableRowItem.Title}}</td>
        <td>
          <div class="flex items-center">

                    <span>
                        {{
                      excelTableInput[tableRowItem.CamelCaseKey]
                        ? excelTableInput[tableRowItem.CamelCaseKey]
                        : ''
                      }}
                    </span>

            <button [attr.data-cy]="'edit-' + tableRowItem.CamelCaseKey" (click)="setData(tableRowItem.Title,tableRowItem.CamelCaseKey,tableRowItem.Type,tableConfigJson[tableType].Source,tableRowItem.IsOptional)" matTooltip="Edit"
                    mat-icon-button class="icon-dropdown-button">
              <i class="fa-solid fa-pen"></i>
            </button>
          </div>
        </td>
      </tr>
      }
      }
      </tbody>
    </table>
  </div>

    <div class="flex flex-row gap-10 hide">
        <button [disabled]="invalid" mat-button class="action-button h-n-35 m-t-10" (click)="apply()">
            Fetch & Convert Fields
        </button>
        <button *ngIf="isTrialBalance === false" [disabled]="isFetched === false" mat-button
            class="action-button h-n-35 m-t-10" (click)="assignDataType()">
            Assign Data Type
        </button>


    </div>
</div>
